import {
  TTranslation,
} from './item-generic-settings.ts';

import {
  EAppId,
} from '@/types/app-type.ts';
import {
  ESettingsSectionType,
} from '@/types/settings.ts';

const translation: TTranslation = {
  [EAppId.TENANT_SETTINGS]: {
    [ESettingsSectionType.APP_OVERVIEW]: {
      title: 'Prehľad aplikácií',
      subtitle: 'Nasledujúce nastavenia určujú prehľad aplikácií, bočný panel aplikácií a strom oprávnení správy používateľov pre všetkých používateľov.',
      settingsMap: {
        appGrouping: {
          label: 'Zoskupenie aplikácií',
          tooltip: 'Určuje, podľa akých skupín sú aplikácie usporiadané pre všetkých používateľov.',
          choices: {
            Department: 'Podľa oddelenia (Príprava výroby, Výroba, Zabezpečenie kvality, Vyhodnotenie, Kmeňové údaje, Administrácia)',
            Topic: 'Podľa témy (Prevádzka, Proces, Údaje / Prehľad, Údržba, Konfigurácia)',
          },
        },
      },
    },
  },
  [EAppId.REMOTE_CONTROL]: {
    [ESettingsSectionType.REMOTE_CONTROL_PT9800]: {
      title: 'Kontrolér PT9800',
      subtitle: 'Nasledujúce nastavenia určujú, ako sa kontrolér PT9800 správa pre každého používateľa.',
      settingsMap: {
        enforceBarcodeScanner: {
          label: 'Vynútiť skenery čiarových kódov.',
          tooltip: 'Ak je táto možnosť zaškrtnutá, v dialógovom okne spustenia zákazky sa vyžaduje potvrdenie dielov pomocou skenera čiarových kódov.',
        },
      },
    },
  },
};

export default translation;
